import { IconPropsType } from '..';

export const WaitingIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <g clipPath="url(#clip0_5038_69205)">
      <path d="M7.99445 0.699951L7.0002 1.69421L7.49732 2.18904L5.83985 3.84995L6.46183 6.46159L3.8502 5.83961L2.18929 7.49708L1.69445 6.99995L0.700195 7.99421L6.00594 13.3L7.0002 12.3057L6.50307 11.8109L8.16054 10.15L7.53856 7.53831L10.1502 8.1603L11.8111 6.50282L12.3059 6.99995L13.3002 6.0057L7.99445 0.699951ZM6.00594 11.3103L5.5111 10.8132L5.49278 10.7948L6.45267 9.83495L6.01281 7.99077L4.16863 7.55091L3.20874 8.51081L3.18698 8.48904L2.68985 7.99077L4.07012 6.61622L6.7482 7.25195L7.38507 9.93002L6.00594 11.3103ZM9.93027 7.38482L7.25219 6.74795L6.61532 4.06988L7.98987 2.69533L11.306 6.01715L9.93027 7.38482Z" />
    </g>
    <defs>
      <clipPath id="clip0_5038_69205">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
